import React from 'react'
import { Hugeicon } from '../../../../icons/Hugeicon'

export const LocationIcon: React.FC = () => <Hugeicon name="location" size={16} />

export const GlobeIcon: React.FC = () => <Hugeicon name="globe" size={16} />

export const PhoneIcon: React.FC = () => <Hugeicon name="call" size={16} />

export const EmailIcon: React.FC = () => <Hugeicon name="mail" size={16} />

export const UsersIcon: React.FC = () => <Hugeicon name="user-multiple" size={20} />

export const UserPlusIcon: React.FC = () => <Hugeicon name="user-add" size={16} />

export const BuildingIcon: React.FC = () => <Hugeicon name="bank" size={32} />

export const CameraIcon: React.FC = () => <Hugeicon name="camera" size={14} />

export const TrashIcon: React.FC = () => <Hugeicon name="delete" size={14} />

export const LogOutIcon: React.FC = () => <Hugeicon name="logout" size={16} />

export const ArrowRightLeftIcon: React.FC = () => <Hugeicon name="arrow-left-right" size={18} />
